import { injectReducer } from '../../store/reducers';

export const AddHotel = store => ({
  path: 'addhotel',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    const AddHotelComponent = require('./containers/AddHotelContainer').default; // eslint-disable-line global-require
    const reducer = require('./modules/hotels').default; // eslint-disable-line global-require

    injectReducer(store, { key: 'hotels', reducer });
    /*  Return getComponent   */
    cb(null, AddHotelComponent);
  },
});

export const AddNewHotel = store => ({
  path: 'addnewhotel',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    const AddNewHotelComponent = require('./containers/AddNewHotelContainer').default; // eslint-disable-line global-require
    const reducer = require('./modules/hotels').default; // eslint-disable-line global-require
    const reducer2 = require('../tours/modules/tour').default;
    injectReducer(store, { key: 'hotels', reducer });
    /*  Return getComponent   */
    cb(null, AddNewHotelComponent);
  },
});

export const RegisterHotel = store => ({
  path: 'hotel/register',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    const RegisterHotelComponent = require('./containers/RegisterHotelContainer').default; // eslint-disable-line global-require
    const reducer = require('./modules/hotels').default; // eslint-disable-line global-require

    injectReducer(store, { key: 'hotels', reducer });
    /*  Return getComponent   */
    cb(null, RegisterHotelComponent);
  },
});

export const BrowseHotel = store => ({
  path: 'browse/hotels',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    const Hotels = require('./containers/BrowseHotelsContainer').default; // eslint-disable-line global-require
    const reducer = require('./modules/hotels').default; // eslint-disable-line global-require
    injectReducer(store, { key: 'hotels', reducer });
    /*  Return getComponent   */
    cb(null, Hotels);
  },
  childRoutes: [
    {
      path: ':id(/:action(/:detail))',
      getComponent(nextState, cb) {
        const DetailContainer = require('./containers/BrowseHotelDetailContainer').default; // eslint-disable-line global-require
        const reducer = require('./modules/hotels').default; // eslint-disable-line global-require
        injectReducer(store, { key: 'hotels', reducer });
        cb(null, DetailContainer);
      },
    },
  ],
});

export default store => ({
  path: 'hotels',
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    const Hotels = require('./containers/HotelsContainer').default; // eslint-disable-line global-require
    const reducer = require('./modules/hotels').default; // eslint-disable-line global-require
    injectReducer(store, { key: 'hotels', reducer });
    /*  Return getComponent   */
    cb(null, Hotels);
  },
  childRoutes: [
    {
      path: ':id',
      getComponent(nextState, cb) {
        const DetailContainer = require('./containers/HotelDetailContainer').default; // eslint-disable-line global-require
        const reducer = require('./modules/hotels').default; // eslint-disable-line global-require
        injectReducer(store, { key: 'hotels', reducer });
        cb(null, DetailContainer);
      },
    },
    {
      path: 'users/:id',
      getComponent(nextState, cb) {
        const HotelUsersContainer = require('./containers/HotelUsersContainer').default; // eslint-disable-line global-require
        const reducer = require('./modules/hotels').default; // eslint-disable-line global-require
        injectReducer(store, { key: 'hotels', reducer });
        cb(null, HotelUsersContainer);
      }
    }
  ],
});


// WEBPACK FOOTER //
// src/routes/hotels/index.js